<template>
<div class="dcplist">
    <el-tabs class="tabs" v-model="selectedTab" @tab-click="handleSwitchTab">
        <el-tab-pane :label="$t('app.project_internal')" name="1"></el-tab-pane>
        <el-tab-pane :label="$t('app.project_external')" name="2" v-if="buOptions.count"></el-tab-pane>
    </el-tabs>
    <el-input :placeholder="$t('app.dcp_search_placeholder')" class="search" @focus="showBasicSearch" :value="searchOptions.text"></el-input>

    <div class="list-container" v-show="!showSearchPannel">
    <div class="infinite-list-wrapper" style="overflow:auto">
    <ul
      class="list"
      v-infinite-scroll="load"
      infinite-scroll-disabled="disabled">
      <li v-for="dcp in dcpList" class="list-item">

        <div class="list-container">
          <div class="list-cell">
            <div class="dataname" @click="viewDcpDetail(dcp)">
              <span>{{$t('app.dcp_data_name')}}: {{dcp.dataName}}</span>
              <div class="right">
                <img
                    src="@/assets/arrow-right.png"
                    width="20px"
                />
              </div>
            </div>
            <div class="buname" v-if="dcp.fromBuName" @click="viewDcpDetail(dcp)">
              {{$t('app.dcp_bu')}}: {{dcp.fromBuName}}
            </div>
            <div class="buname" v-if="dcp.fromProjectName" @click="viewDcpDetail(dcp)">
              {{$t('app.dcp_project')}}: {{dcp.fromProjectName}}
            </div>
            <div class="buname" v-if="dcp.fromDcpName" @click="addDcp(dcp)">
              {{$t('app.dcp_type')}}: {{dcp.fromDcpName}}
            </div>
            <div class="updatetime" v-if="dcp.updateTime" @click="addDcp(dcp)">
              <span>{{$t('app.dcp_update_date')}}: {{dateFormat(dcp.updateTime)}}</span>
              <img
                    src="@/assets/add.png"
                    width="20px"
                />
            </div>
          </div>
        </div>
        </li>
    </ul>
  </div>
  </div>

  <transition name="el-zoom-in-top">
    <div class="search-pannel" v-show="showSearchPannel">
        <transition name="el-fade-in-linear">
            <div class="basic-search" v-show="searchMode == 'basic'">
                <el-input :placeholder="$t('app.dcp_data_name')" class="basic-search-input" v-model="searchOptions.tempText" ref="basicInputRef" @keyup.enter.native="searchDcpByText"></el-input>
                <el-button plain size="mini" class="basic-search-btn" @click="showAdvancedSearch">{{$t('app.dcp_advanced_search')}}</el-button>
                <el-button plain size="mini" class="basic-search-btn" @click="cancelSearch">{{$t('app.dcp_search_cancel')}}</el-button>
            </div>
        </transition>
        <transition name="el-fade-in-linear">
        `    <div class="advanced-search" v-show="searchMode == 'advanced'">
                <el-form label-position="top" flex>
                    <el-form-item :label="$t('app.dcp_filter_name')">
                        <el-input :placeholder="$t('app.dcp_data_name')" v-model="searchOptions.tempText"></el-input>
                    </el-form-item>
                    <el-form-item label="DCP" v-model="searchOptions.dcp" v-if="selectedTab=='1'">
                        <el-select v-model="searchOptions.dcp" :placeholder="$t('app.dcp_options_placeholder')" style="width: 100%;">
                            <el-option
                            v-for="item in dcpOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('app.dcp_bu')" v-model="searchOptions.buname" v-if="selectedTab=='2'">
                        <el-select v-model="searchOptions.buname" :placeholder="$t('app.dcp_options_placeholder')" style="width: 100%;">
                            <el-option
                            v-for="item in buOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('app.dcp_start_time')">
                        <el-date-picker
                        v-model="value1"
                        type="date"
                        style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('app.dcp_end_time')">
                        <el-date-picker
                        v-model="value2"
                        type="date"
                        style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                </el-form>

                <div class="search-btns">
                    <div class="cancel" @click="cancelSearch">
                        <span>{{$t('app.dcp_cancel')}}</span>
                    </div>
                    <div class="confirm" @click="confirmSearch">
                        <span>{{$t('app.dcp_confirm')}}</span>
                    </div>
                </div>
            </div>`
        </transition>
    </div>
  </transition>

    <mt-popup
      v-model="selectValueDialogVisible"
      position="bottom">
      <div class="select-text-pannel">
        <div class="content">
          <div>{{selectedValueLabel}}</div>
          <div class="ref-input-content">
            <span>{{selectedValue}}</span>
          </div>
          <div class="bottom-btn">
            <el-button plain size="mini" @click="selectValueDialogVisible=false">{{$t('app.dcu_close')}}</el-button>
            <el-button size="mini" type="primary" @click="confirmSelectDcpValue">{{$t('app.dcu_confirm')}}</el-button>
          </div>
        </div>
      </div>
    </mt-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import getreflist from "@/localdata/getreflist"
import callApp from "@/services/sdk";
  export default {
    data () {
      return {
        count: 100,
        loading: false,
        showSearchPannel: false,
        dcpOptions: [],
        buOptions: [],
        value: '',
        value1: '',
        value2: '',
        searchMode: 'basic',
        basicText: '',
        refDcpHostKey: '',
        cxtContent: '',
        searchOptions: {
            text: "",
            buname: "",
            date: [],
            tempText: "",
            dcp: ''
        },
        selectedTab: "1",
        selfRefDcpList: [],
        otherRefDcpList: [],
        dcpList: [],
        selfDcpList: [],
        dcpRequestParams: {
          dcpType: "",
          dcpUuid: "",
          dcu: false,
          dcuPath: "",
          endTime: 0,
          fromBuUuid: [],
          fromDataName: "",
          fromDcpUuid: "",
          fromProjectName: "",
          internal: true,
          needPage: true,
          old: false,
          page: 0,
          projectId: "",
          size: 20,
          startTime: 0
        },
        showRefTextPannel: false,
        type: "dcp",
        selectedValue: "",
        selectedValueLabel: "",
        selectedDcp:{},
        selectValueDialogVisible: false,
        noMore: false
        }
    },
    computed: {
    ...mapGetters([
      'getChildPageContext'
    ]),
    pageContext() {
      return this.getChildPageContext[this.refDcpHostKey]
    },
      // noMore () {
      //   return this.count >= 20
      // },
      disabled () {
        return this.loading || this.noMore
      }
    },
    methods: {
      load () {
        // this.loading = true
        // setTimeout(() => {
          this.dcpRequestParams.page += 1
          this.loadMoreData()
          // this.dcpList = this.dcpList.concat(getreflist.data.refDcpList);
          // this.loading = false
        // }, 2000)
      },
      searchDcpByText(){
        this.showSearchPannel = false;
        this.searchOptions.text = this.searchOptions.tempText
        this.dcpRequestParams.fromDataName = this.searchOptions.tempText
        this.dcpList = []
        this.noMore = false
        this.dcpRequestParams.page = 1
        // this.dcpRequestParams.dcuPath = this.getChildPageContext.hostKey
        // this.dcpRequestParams.internal = this.selectedTab == "1"
        // this.dcpRequestParams.dcpUuid = this.getChildPageContext.father.uuid
        // this.dcpRequestParams.projectId = this.getChildPageContext.father.projectId
        // callApp(
        //   "getData",
        //   {
        //     type: `dataSource.server.getrefdcplist`,
        //     data: this.dcpRequestParams
        //   },
        //   "cbGetData"
        // ).then(data => {
        //   this.$nextTick(() => {
        //     // this.selfRefDcpList = data.refDcpList
        //     this.dcpList = data.refDcpList
        //   });
        // });
        this.refreshDcpList()
      },
      dcpDetail(row) {
          this.$router.push({path: "/v2/dcpdetail",query: { action: "preview" }})
      },
      addDcp(row) {

          if(this.type == "dcp"){
              let childPageContext = this.getChildPageContext
              let refObject = childPageContext[this.refDcpHostKey]
              let refContent = (refObject && refObject.refContent) || []
              let exist = false
              refContent.forEach(element=>{
                if(element.dataHash === row.dataHash){
                  exist = true
                }
              })
              if(!exist){
                refContent = refContent.concat([row])
              }
              refObject = {...refObject, refContent}
              childPageContext[this.refDcpHostKey] = refObject
              this.$store.dispatch('setChildPageContext', childPageContext)
              this.$router.back()
          }else{
              this.selectedDcp = row;
              try{
                var params = {
                    dcpUuid: this.pageContext.father.uuid,
                    dcuPath: this.refDcpHostKey || "",
                    projectId: this.pageContext.father.projectId,
                    source: (this.selectedTab === '1') ? 'internal' : 'external',
                    fromDcpUuid: row.fromDcpUuid || ''
                }
                callApp(
                  "getData",
                  {
                    type: `dataSource.server.getrefdcpconfiglist`,
                    data: params
                  },
                  "cbGetData"
                ).then(data => {
                  // let data = getdcpconfiglist.data
                  this.$nextTick(() => {
                    this.inboundDcuPath = data
                    let inboundRefList = data[0].refList || []
                    let refConfigList = data
                    if (inboundRefList.length > 0) {
                      let inboundDcuPath = inboundRefList[0].refDcuPath
                      this.inboundDcuPath = inboundDcuPath
                      callApp(
                        "getData",
                        {
                          type: `dataSource.server.getrefdcpdetail`,
                          data: row
                        },
                        "cbGetData"
                      ).then(newData => {
                          // let newData = getrefdcpdetail.data
                          const templateData = newData
                          let datamodelData = templateData.data;
                          let template = templateData.template.attributes;

                          let _path = inboundDcuPath.split('.')
                          let getValueFromJson = this.getValueFromJson(_path, datamodelData)

                          this.selectedValue = getValueFromJson

                          let attrFromJson = this.getAttrFromJson(_path, template)
                            this.selectedValueLabel = attrFromJson.displayReference.label
                            let convertValueByType = this.convertValueByType(attrFromJson, this.selectedValue)
                            if (convertValueByType) {
                              this.selectedValue = convertValueByType
                            }

                            this.selectValueDialogVisible = true

                        });
                    }
                  });
                });
              } catch(err){}
          }

          // }, 1000)
      },
      getValueFromJson(path, dataValue){
          let subObject = dataValue
          path.forEach(pathElement => {
            if (Object.prototype.toString.call(subObject) === '[object Array]') {
              subObject = (subObject.length > 0)
                  ? (subObject[0].value
                  ? subObject[0].value
                  : subObject[0]) : ''
            } else if (Object.prototype.toString.call(subObject) === '[object Object]') {
              subObject = subObject[pathElement]
            } else {
              return subObject
            }
          })

          return subObject
      },
      getAttrFromJson(path, attributes){
          let subObject = attributes
          path.forEach(pathElement => {
          if (Object.prototype.toString.call(subObject) === '[object Array]') {
            let filterElement = subObject.filter(item => item.key === pathElement)[0]
            let dataReference = filterElement.dataReference
            if (dataReference.attributes) {
              subObject = dataReference.attributes
            } else if (dataReference.itemType) {
              subObject = dataReference.itemType
            } else {
              subObject = filterElement
            }
          } else {
            return subObject
          }
        })

        return subObject
      },
      convertValueByType(attrFromJson, selectedValue){
          let value = selectedValue
        if (attrFromJson.type) {
          if (attrFromJson.type === '00000000-0000-0000-0000-000000000005') {
            value = dateFormat(new Date(selectedValue))
          } else if (attrFromJson.type === '00000000-0000-0000-0000-000000000006') {
            value = dateFormat(new Date(selectedValue), 'yyyy-MM-dd')
          } else if (attrFromJson.type === '00000000-0000-0000-0000-000000000009') {
            if (attrFromJson.controlReference && attrFromJson.controlReference.options) {
              let filterSelectValue = attrFromJson.controlReference.options.filter(item =>
                item.value === selectedValue) || []
              if (filterSelectValue.length > 0) {
                value = filterSelectValue[0].label
              }
            }
          }
        }
        return value
      },
      showBasicSearch() {
        this.showSearchPannel = true;
        this.searchMode = 'basic'
        this.$nextTick(() => {
            this.$refs["basicInputRef"].focus();
        });
      },
      showAdvancedSearch() {
        this.showSearchPannel = true;
        this.searchMode = 'advanced'
        // this.$nextTick(() => {
        //     this.$refs["inputRef"].focus();
        // });
      },
      resetSearch() {
          this.searchMode = ""
          this.value1 = ''
          this.value2 = ''
          this.searchOptions.tempText = this.searchOptions.text
      },
      cancelSearch() {
          this.showSearchPannel = false;
          this.resetSearch()
      },
      confirmSearch() {
          this.confirmSearchParams()
          this.dcpList = []
          this.noMore = false
          this.dcpRequestParams.page = 1
          this.refreshDcpList()
      },
      confirmSearchParams() {
          this.showSearchPannel = false;
          this.searchOptions.text = this.searchOptions.tempText
          this.dcpRequestParams.fromBuUuid = this.searchOptions.buname.length ? [this.searchOptions.buname] : []
          this.dcpRequestParams.internal = false
          this.dcpRequestParams.fromDataName = this.searchOptions.tempText
          this.dcpRequestParams.startTime = this.value1 ? new Date(this.value1).getTime() : ''
          this.dcpRequestParams.endTime = this.value2 ? new Date(this.value2).getTime() : ''
          this.dcpRequestParams.fromDcpUuid = this.searchOptions.dcp
      },
      loadMoreData() {
          this.confirmSearchParams()
          this.refreshDcpList()
      },
      handleSwitchTab() {
          this.dcpRequestParams.internal = this.selectedTab == "1"
          this.searchOptions.dcp = ""
          this.searchOptions.buname = ""
          this.dcpList = []
          this.noMore = false
          this.resetPage()
          this.refreshDcpList()
      },
      resetPage() {
        this.dcpRequestParams.page = 1
      },
      refreshDcpList() {
        try {

          this.dcpRequestParams.dcuPath = this.pageContext.hostKey
          this.dcpRequestParams.dcpUuid = this.pageContext.father.uuid
          this.dcpRequestParams.projectId = this.pageContext.father.projectId
          this.dcpRequestParams.internal = this.selectedTab == "1"
          callApp(
            "getData",
            {
              type: `dataSource.server.getrefdcplist`,
              data: this.dcpRequestParams
            },
            "cbGetData"
          ).then(data => {
            this.$nextTick(() => {

              let addItems = data.refDcpList.filter(element => {
                let filteredItems = this.dcpList.filter(item=>{
                  return element.dataHash == item.dataHash
                })
                return filteredItems.length <= 0
              })

              this.dcpList = this.dcpList.concat(addItems)
              if(data.refDcpList.length < 20){
                this.noMore = true
              }
            });
          });
        } catch (err) {}
      },
      viewDcpDetail(dcp){
          this.$store.dispatch('setViewDcp', dcp)
          this.$router.push({path: "/v2/dcpdetail",query: { action: "view" }})
      },
      confirmSelectDcpValue() {

        this.selectValueDialogVisible = false
        let refData = {
          'reference': {
            'datavid': this.selectedDcp.dataVid,
            'datauuid': this.selectedDcp.dataUuid,
            'datahash': this.selectedDcp.dataHash,
            'txid': this.selectedDcp.txid,
            'clauseindex': this.selectedDcp.clauseIndex,
            'keypath': this.inboundDcuPath
          },
          'storagekey': this.refDcpHostKey
        }
        var refContent = {value: this.selectedValue, refData}
        let context = {...this.getChildPageContext[this.refDcpHostKey], refContent}
        let childPageContext = this.getChildPageContext
        childPageContext[this.refDcpHostKey] = context
        this.$store.dispatch('setChildPageContext', childPageContext)
        setTimeout(()=>{
          this.$router.back();
        }, 300)
      },
      dateFormat(date = '', format = 'yyyy-MM-dd HH:mm:ss'){
        if (/^.*T.*.0{3}\+0{4}$/.test(date)) {
          // eslint-disable-next-line no-useless-escape
          date = new Date(date.replace(/\-/g, '/').replace('T', ' ').replace(/\.\d{3}/, ' GMT'))
        }
        const types = (val) => {
          return Object.prototype.toString.call(val).match(/^\[\w+\s+(\w+)\]$/i)[1].toLowerCase()
        }
        var isDate = (val) => {
          return types(val) === 'date'
        }
        const toNumber = (num) => {
          return parseFloat(num)
        }
        const coverData = (obj = '', n = 2) => {
          obj = obj.toString()
          if (obj.length >= n) {
            return obj
          }
          obj = '0000000000' + obj
          return obj.substr(obj.length - n)
        }
        if (isDate(date)) {
          date = Date.parse(date)
        }
        if (!/^\d{10,}$/.test(date)) {
          return ''
        }
        date = new Date(toNumber((date.toString() + '0000000000000').substr(0, 13)))
        let y = date.getFullYear()
        let M = date.getMonth() + 1
        let d = date.getDate()
        let h = date.getHours()
        let m = date.getMinutes()
        let s = date.getSeconds()
        format = format.replace('yyyy', y)
        format = format.replace('MM', coverData(M))
        format = format.replace('M', M)
        format = format.replace('dd', coverData(d))
        format = format.replace('d', d)
        format = format.replace('HH', coverData(h))
        format = format.replace('H', h)
        format = format.replace('mm', coverData(m))
        format = format.replace('m', m)
        format = format.replace('ss', coverData(s))
        format = format.replace('s', s)
        return format
      }
    },
    mounted() {
        /// get self ref dcp list
        try {
        // const ddd = refdcp
        // let data = ddd.data
        // // this.origin_data = {"language": "begin"}
        // this.$nextTick(() => {
        // 	// this.origin_data = data.statusData
        // 	if (data.statusData) {
        // 		// this.origin_data = {"language": "aaaaa"}
        // 		this.$store.dispatch('setFormStatus', data.statusData.editStatus || 'edit')
        // 	// this.origin_data = {"language": "bbb"}
        // 		this.$store.dispatch('setDataPointType', data.statusData.dataPoint)
        // 		// this.origin_data = {"language": "cc"}
        // 		this.$store.dispatch('setSoftDataStatus', data.statusData.softDataStatus)
        // 		// this.origin_data = {"language": "ddd"}
        // 		this.$store.state.domain =  data.statusData.domain
        // 		// this.origin_data = {"language": "eee"}
        // 		this.$store.state.token =  data.statusData.token
        // 		// this.origin_data = {"language": "fff"}
        // 	}
        // 	this.formStatus = data.statusData.editStatus
        // 	if (data.language) {
        // 		this.$store.state.languagePackage.push(data.language)
        //     }
        //     this.template = data.template.attributes
        //     this.datamodel = data.data
        //     this.$store.state.uuid =  data.template.uuid
        // })

        // this.dcpList = getreflist.data.refDcpList;
        // this.refDcpHostKey = "custom.textplain_001"
        // this.type = "dcu"
        // return false

        this.refDcpHostKey = this.$route.query.hostKey
        this.type = this.$route.query.type

        this.dcpRequestParams.old = this.$route.query.old && this.$route.query.old == "true" ? true : false
        var dcpType = this.dcpRequestParams.old && "BATCH" || ""
        this.dcpRequestParams.dcpType = dcpType
        this.dcpRequestParams.dcuPath = this.pageContext.hostKey
        this.dcpRequestParams.internal = true
        this.dcpRequestParams.dcpUuid = this.pageContext.father.uuid
        this.dcpRequestParams.projectId = this.pageContext.father.projectId
        callApp(
          "getData",
          {
            type: `dataSource.server.getrefdcplist`,
            data: this.dcpRequestParams
          },
          "cbGetData"
        ).then(data => {
          this.$nextTick(() => {
            this.selfRefDcpList = data.refDcpList
            this.dcpList = data.refDcpList
          });
        });

        var params = {
          dcpUuid: this.pageContext.father.uuid,
          projectId: this.pageContext.father.projectId,
          needPage: false,
          page: 0,
          size: 0,
        }
        callApp(
          "getData",
          {
            type: `dataSource.server.getrefbulist`,
            data: params
          },
          "cbGetData"
        ).then(data => {
          this.$nextTick(() => {
            this.buList = data.buList
            this.buOptions = this.buList.map(element=>{
              return {
                value: element.fromBuUuid,
                label: element.fromBuName
              }
            })
          });
        });

        callApp(
          "getData",
          {
            type: `dataSource.server.getprojectdcplist`,
            data: {}
          },
          "cbGetData"
        ).then(data => {
          this.$nextTick(() => {
            this.selfDcpList = data.dcpList
            this.dcpOptions = this.selfDcpList.map(element=>{
              var dataModelInfos = element.processDetail.dataModelInfos
              var name = dataModelInfos[0].modelName || element.processDetail.processName
              var modelUuid = element.instanceUuid
              return {
                value: modelUuid,
                label: name
              }
            })

          });
        });

      } catch (err) {}
    }
  }
</script>

<style lang='scss' scoped>
.dcplist {
    padding: 10px;
    font-size: 14px;
}
// .list-container {
//     padding-top: 120px;
//     // top: 60px;
//     height: calc(100%-140px);
// }
.infinite-list-wrapper {
  height: calc(100vh - 94px);;
//   border: 1px solid #9b9b9b;
//   border-radius: 4px;
}
.searchHeader {
    position: fixed;
    // display: flex;
    // flex-direction: column;
    width: 100vw;
    z-index: 10;
    background-color: white;
    padding: 10px;
    // .tabs, .search {
    //     margin-left: 10px;
    //     margin-top: 10px;
    //     margin-right: 10px;
    // }
}
ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
}
li {
    list-style-type:none;
    }
.list-item {
    // height: 120px;
}
.list-container {
  margin-bottom: 10px;
}
.list-cell {
    // width: calc(100vw - 20px);
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    .cell-title {
        display: flex;
        // flex-direction: column;
        justify-content: space-between;
        img {
            width: 20px;
        }

    }
    .dataname , .updatetime {
      display: flex;
      justify-content: space-between;
      .el-icon-arrow-right {
        width: 22px;
        height: 22px;
      }
    }
    .updatetime {
      align-items: center;
    }
}
.search-pannel {
    position: absolute;
    top: 60px;
    left: 0px;
    right: 0px;
    padding-left: 10px;
    padding-right: 10px;
    height: calc(100vh - 60px);
    background-color: white;
    z-index: 11;
    .basic-search-btn {
        margin: 0px 10px;
    }
    .basic-search, .advanced-search {
        display: flex;
    }
    .advanced-search {
        flex-direction: column;
        .search-btns {
            display: flex;
            justify-content: space-around;
            .cancel, .confirm {
                width: 120px;
                height: 40px;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .confirm {
                background-color: black;
                color: white;
            }
            .cancel {
                background-color: white;
                color: black;
                border: 1px solid black;
            }
        }
    }
}
.select-text-pannel{
  width: 100vw;
  .content {
    margin: 20px;
    display: flex;
    flex-direction: column;
    .ref-input-content {
      margin: 10px 0px;
      padding-left: 10px;
      height: 35px;
      width: calc(100vw - 40px);
      background-color: #f2f2f2;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }
    .bottom-btn {
      display: flex;
      justify-content: space-between;
      margin: 10px 20px;
    }
  }
  // height: auto;
}
</style>
